import {Link} from "react-router-dom";
import styled from "styled-components";

export const CourierLink = styled(Link)`
    pointer-events: ${({activelink}) => (activelink === "true" ? "none" : "default")};
    color: ${({activelink}) => (activelink === "true" ? "inherit" : "default")};
    font-weight: bold;
    text-decoration: none;
`;
